export const driverRequire = [
  'mobile',
  'identityPositiveImage',
  'identityReverseImage',
  'driverLicenseOriginalImage',
  'driverLicenseDeputyImage',
  'name',
  'grossMass',
  'identityNumber',
  'identityValidityStart',
  'identityValidityEnd',
  'identityAddress',
  'driverNo',
  'driverLicenseType',
  'driverLicenseValidityStart',
  'driverLicenseValidityEnd',
  'professionalNumber',
  'professionalType',
  'professionalValidityStart',
  'professionalValidityEnd',
  // 'professionalImage',
  'identityLicenseAgency',
  'vehicleLicenseAuthority',
  'vehicleLicenseRegisterDate',
  'vehicleLicenseIssueDate',
  'natureUsage',
  'cargoTonnage',
  'drivingLicenseEndDate',
  'drivingLicenseFileNumber',
  'vehicleBrand',
  'engineNo',
  'drivingPermitPhotosExtra',
  'vehicleFrontImage',
  'merchantName',
];

function checkMobile(rule, value, callback) {
  if (!value) {
    callback(new Error('手机号不能为空'));
  }
  if (/^1[3-9][0-9]\d{8}/.test(value)) {
    callback();
  } else {
    callback(new Error('输入正确手机号'));
  }
}

function checkName(rule, value, callback) {
  if (!value) {
    callback(new Error('姓名不能为空'));
  }
  if (/^([\p{Unified_Ideograph}·]){2,20}$/u.test(value)) {
    callback();
  } else {
    callback(new Error('输入正确姓名'));
  }
}

function checkIdCard(rule, value, callback) {
  if (!value) {
    callback(new Error('身份证号不能为空'));
  }
  if (
    /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/.test(
      value,
    )
  ) {
    callback();
  } else {
    callback(new Error('输入正确身份证号'));
  }
}

function checkDriverNo(rule, value, callback) {
  if (!value) {
    callback(new Error('驾驶证号不能为空'));
  }
  if (
    /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/.test(
      value,
    )
  ) {
    callback();
  } else {
    callback(new Error('输入正确驾驶证号'));
  }
}

function checkVehicleNo(rule, value, callback) {
  if (!value) {
    callback(new Error('车牌号不能为空'));
  }
  if (
    /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z].{5,6}$/.test(value)
  ) {
    callback();
  } else {
    callback(new Error('输入正确车牌号'));
  }
}

function checkValue(rule, value, callback) {
  if (!value && rule.require) {
    return callback(new Error(rule.message));
  } else {
    return callback();
  }
}

function checkArrValue(rule, value, callback) {
  if (!value.length && rule.require) {
    return callback(new Error(rule.message));
  } else {
    return callback();
  }
}

function checkVehicleLength(rule, value, callback) {
  if (rule.require) {
    if (value || value == '0') {
      return callback();
    } else {
      return callback(new Error(rule.message));
    }
  } else {
    return callback();
  }
}

export const rules = {
  identityPositiveImage: [
    {
      validator: checkValue,
      message: '上传身份证正面',
      trigger: ['blur', 'change'],
    },
  ],
  identityReverseImage: [
    {
      validator: checkValue,
      message: '上传身份证反面',
      trigger: ['blur', 'change'],
    },
  ],
  driverLicenseOriginalImage: [
    {
      validator: checkValue,
      message: '上传驾驶证正页',
      trigger: ['blur', 'change'],
    },
  ],
  driverLicenseDeputyImage: [
    {
      validator: checkValue,
      message: '上传驾驶证副页',
      trigger: ['blur', 'change'],
    },
  ],
  // professionalImage: [
  //   {
  //     validator: checkValue,
  //     message: '上传从业资格证',
  //     trigger: ['blur', 'change'],
  //   },
  // ],
  vehicleLicenseOriginalImage: [
    {
      validator: checkValue,
      message: '上传行驶证正页',
      trigger: ['blur', 'change'],
    },
  ],
  vehicleLicenseDeputyImage: [
    {
      validator: checkValue,
      message: '上传行驶证副页',
      trigger: ['blur', 'change'],
    },
  ],
  drivingPermitPhotosExtra: [
    {
      validator: checkValue,
      message: '上传行驶证年检页',
      trigger: ['blur', 'change'],
    },
  ],
  trailerLicenseOriginalImage: [
    {
      validator: checkValue,
      message: '挂车行驶证正面',
      trigger: ['blur', 'change'],
    },
  ],
  trailerLicenseDeputyImage: [
    {
      validator: checkValue,
      message: '挂车行驶证副页',
      trigger: ['blur', 'change'],
    },
  ],
  trailerDrivingPermitPhotosExtra: [
    {
      validator: checkValue,
      message: '挂车行驶证年检页',
      trigger: ['blur', 'change'],
    },
  ],
  trailerLicenseNo: [
    {
      validator: checkValue,
      message: '车牌号不能为空',
      trigger: ['blur', 'change'],
    },
  ],
  transportImage: [
    {
      validator: checkValue,
      message: '上传道路运输证',
      trigger: ['blur', 'change'],
    },
  ],
  transportImageExtra: [
    {
      validator: checkValue,
      message: '上传道路运输证年检页',
      trigger: ['blur', 'change'],
    },
  ],
  licensePhotoExtra: [
    {
      validator: checkValue,
      message: '上传营运证年检页',
      trigger: ['blur', 'change'],
    },
  ],
  vehicleFrontImage: [
    {
      validator: checkValue,
      message: '上传车头照',
      trigger: ['blur', 'change'],
    },
  ],
  mobile: [{ validator: checkMobile, trigger: ['blur', 'change'] }],
  name: [{ validator: checkName, trigger: ['blur', 'change'] }],
  identityNumber: [{ validator: checkIdCard, trigger: ['blur', 'change'] }],
  identityValidityStart: [
    {
      validator: checkValue,
      message: '选择身份证开始时间',
      trigger: ['blur', 'change'],
    },
  ],
  identityValidityEnd: [
    {
      validator: checkValue,
      message: '选择身份证终止时间',
      trigger: ['blur', 'change'],
    },
  ],
  vehicleLicenseRegisterDate: [
    {
      validator: checkValue,
      message: '选择注册日期',
      trigger: ['blur', 'change'],
    },
  ],
  vehicleLicenseIssueDate: [
    {
      validator: checkValue,
      message: '选择发证日期',
      trigger: ['blur', 'change'],
    },
  ],
  professionalNumber: [
    {
      validator: checkValue,
      message: '资格证号不能为空',
      trigger: ['blur', 'change'],
    },
  ],
  identityLicenseAgency: [
    {
      validator: checkValue,
      message: '签发机关不能为空',
      trigger: ['blur', 'change'],
    },
  ],
  professionalType: [
    {
      validator: checkValue,
      message: '资格证类型不能为空',
      trigger: ['blur', 'change'],
    },
  ],
  natureUsage: [
    {
      validator: checkValue,
      message: '使用性质不能为空',
      trigger: ['blur', 'change'],
    },
  ],
  cargoTonnage: [
    {
      validator: checkVehicleLength,
      message: '载货质量不能为空',
      trigger: ['blur', 'change'],
    },
  ],
  drivingLicenseEndDate: [
    {
      validator: checkValue,
      message: '行驶证有效期至不能为空',
      trigger: ['blur', 'change'],
    },
  ],
  drivingLicenseFileNumber: [
    {
      validator: checkValue,
      message: '档案编号不能为空',
      trigger: ['blur', 'change'],
    },
  ],
  vehicleBrand: [
    {
      validator: checkValue,
      message: '品牌型号不能为空',
      trigger: ['blur', 'change'],
    },
  ],
  engineNo: [
    {
      validator: checkValue,
      message: '发动机号不能为空',
      trigger: ['blur', 'change'],
    },
  ],
  identityAddress: [{ validator: checkValue, message: '输入地址', trigger: ['blur', 'change'] }],
  driverNo: [{ validator: checkDriverNo, trigger: ['blur', 'change'] }],
  driverLicenseValidityStart: [
    {
      validator: checkValue,
      message: '选择驾驶证开始时间',
      trigger: ['blur', 'change'],
    },
  ],
  driverLicenseValidityEnd: [
    {
      validator: checkValue,
      message: '选择驾驶证终止时间',
      trigger: ['blur', 'change'],
    },
  ],
  professionalValidityStart: [
    {
      validator: checkValue,
      message: '选择资格证起始时间',
      trigger: ['blur', 'change'],
    },
  ],
  professionalValidityEnd: [
    {
      validator: checkValue,
      message: '选择资格证终止时间',
      trigger: ['blur', 'change'],
    },
  ],
  driverLicenseType: [{ validator: checkValue, message: '输入地址', trigger: ['blur', 'change'] }],
  driverLicenseAgency: [
    {
      validator: checkValue,
      message: '输入发证机关',
      trigger: ['blur', 'change'],
    },
  ],
  merchantName: [
    {
      validator: checkValue,
      message: '输入业户名称',
      trigger: ['blur', 'change'],
    },
  ],
  vehicleNo: [
    {
      validator: checkVehicleNo,
      trigger: ['blur', 'change'],
    },
  ],
  vehicleProperty: [
    {
      validator: checkValue,
      message: '选择车辆性质',
      trigger: ['blur', 'change'],
    },
  ],
  vehicleType: [
    {
      validator: checkValue,
      message: '选择车辆类型',
      trigger: ['blur', 'change'],
    },
  ],
  chassisNo: [
    {
      validator: checkValue,
      message: '输入车架号',
      trigger: ['blur', 'change'],
    },
  ],
  vehicleColor: [
    {
      validator: checkValue,
      message: '选择车牌颜色',
      trigger: ['blur', 'change'],
    },
  ],
  fuelType: [
    {
      validator: checkValue,
      message: '选择能源类型',
      trigger: ['blur', 'change'],
    },
  ],
  grossMass: [
    {
      validator: checkVehicleLength,
      message: '输入总质量',
      trigger: ['blur', 'change'],
    },
  ],
  approverLoad: [
    {
      validator: checkVehicleLength,
      message: '输入核定载重',
      trigger: ['blur', 'change'],
    },
  ],
  totalTractionMass: [
    {
      validator: checkVehicleLength,
      message: '输入牵引总量',
      trigger: ['blur', 'change'],
    },
  ],
  curbWeight: [
    {
      validator: checkVehicleLength,
      message: '输入整备质量',
      trigger: ['blur', 'change'],
    },
  ],
  owner: [
    {
      validator: checkValue,
      message: '输入所有人',
      trigger: ['blur', 'change'],
    },
  ],
  vehicleLicenseAuthority: [
    {
      validator: checkValue,
      message: '输入发证机关',
      trigger: ['blur', 'change'],
    },
  ],
  transportNo: [
    {
      validator: checkValue,
      message: '输入道运证号',
      trigger: ['blur', 'change'],
    },
  ],
  transportOperationNo: [
    {
      validator: checkValue,
      message: '输入许可证号',
      trigger: ['blur', 'change'],
    },
  ],
  shaftNumber: [
    {
      require: true,
      validator: checkValue,
      message: '选择轴数',
      trigger: ['blur', 'change'],
    },
  ],
  vehicleLength: [
    {
      validator: checkVehicleLength,
      message: '输入外廓尺寸(长)',
      trigger: ['blur', 'change'],
    },
  ],
  vehicleWidth: [
    {
      validator: checkVehicleLength,
      message: '输入外廓尺寸(宽)',
      trigger: ['blur', 'change'],
    },
  ],
  vehicleHigh: [
    {
      validator: checkVehicleLength,
      message: '输入外廓尺寸(高)',
      trigger: ['blur', 'change'],
    },
  ],
  oilWear: [
    {
      require: true,
      validator: checkValue,
      message: '输入载重油耗',
      trigger: ['blur', 'change'],
    },
  ],
  etcIssuer: [
    {
      validator: checkValue,
      message: '选择发卡方',
      trigger: ['blur', 'change'],
    },
  ],
  carryCargoLength: [
    {
      validator: checkValue,
      message: '选择车长',
      trigger: ['blur', 'change'],
    },
  ],
  vehicleModel: [
    {
      validator: checkArrValue,
      message: '选择车型',
      trigger: ['blur', 'change'],
    },
  ],
};
